module.exports = __webpack_public_path__ + "static/media/nuevo-logo-wisar.17d07f8e.png";